import React, { useEffect, useRef, useState } from "react";

/**
 * The prompt shown above the videos. The panel reserves a constant height
 * whatever the prompt is, so the videos never move between pairs: long prompts
 * are clamped to three lines and shown in full on hover instead of growing the
 * panel.
 */
const PromptPanel = ({ prompt, error }) => {
  const textRef = useRef(null);
  const [isClamped, setIsClamped] = useState(false);
  const text = prompt?.trim() || "";

  useEffect(() => {
    const element = textRef.current;
    if (!element) return undefined;

    const measure = () => setIsClamped(element.scrollHeight - element.clientHeight > 1);
    measure();

    // Re-measure when the panel is resized, since that changes how much of the
    // prompt fits on three lines.
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [text]);

  const placeholder = error ? "The prompt failed to load" : "No prompt for this pair";

  return (
    <div className="prompt-panel">
      <div className="prompt-panel-header">
        <span className="prompt-panel-label">Prompt</span>
        {isClamped && <span className="prompt-panel-hint">Hover to read it all</span>}
      </div>

      <p
        ref={textRef}
        className={`prompt-panel-text${text ? "" : " is-placeholder"}${
          error && !text ? " is-error" : ""
        }`}
        tabIndex={isClamped ? 0 : undefined}
      >
        {text || placeholder}
      </p>

      {isClamped && (
        <div className="prompt-panel-full" role="tooltip" aria-hidden="true">
          {text}
        </div>
      )}
    </div>
  );
};

export default PromptPanel;
